import { render, staticRenderFns } from "./kuaishou.vue?vue&type=template&id=cdd43998&scoped=true"
import script from "./kuaishou.vue?vue&type=script&lang=js"
export * from "./kuaishou.vue?vue&type=script&lang=js"
import style0 from "./kuaishou.vue?vue&type=style&index=0&id=cdd43998&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd43998",
  null
  
)

export default component.exports